/**
 * Extract quiz sessionId from QR text (plain code or /quiz/:sessionId URL).
 * @param {string} text - Raw QR payload
 * @returns {string|null}
 */
export function parseQuizSessionFromQr(text) {
    const raw = (text || '').trim();
    if (!raw) return null;

    const pathMatch = raw.match(/\/quiz\/([^/?#\s]+)/i);
    if (pathMatch?.[1]) {
        return decodeURIComponent(pathMatch[1]).trim();
    }

    try {
        if (raw.includes('://')) {
            const url = new URL(raw);
            const urlPath = url.pathname.match(/\/quiz\/([^/]+)/i);
            if (urlPath?.[1]) {
                return decodeURIComponent(urlPath[1]).trim();
            }
        }
    } catch {
        // not a valid URL
    }

    const code = raw.split(/[?#\s]/)[0].trim();
    if (/^[A-Za-z0-9_-]{3,50}$/.test(code)) {
        return code;
    }

    return code.length >= 3 && code.length <= 50 ? code : null;
}
